import styled, { css, keyframes } from 'styled-components';
import { media } from '../../css_global/utils.css.js';

const pulse = props => css`
  ${keyframes`
    50% {
      border: 1px solid #FF3333;
      color: #FF3333;
      box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.2);
    }
  `}
`;

const Selector = styled.select`
  appearance: none;
  ${props => (props.s3BasePath ? `background-image: url(${props.s3BasePath}mkt/icon/down_arrow.png);` : null)}
  background-color: ${props => (props.disabled ? '#eeeeee' : 'white')};
  background-position: 94% center;
  background-repeat: no-repeat;
  background-size: 16px;
  border: 1px solid ${props => (props.borderColor ? props.borderColor : '#000')};
  border-radius: 5px;
  color: ${props => (props.color ? props.color : '#000')};
  cursor: pointer;
  font: inherit;
  ${props => (props.font ? `font-family: ${props.font};` : null)}
  font-size: ${props => (props.fontSize ? props.fontSize : '15px')};
  outline: none;
  overflow: hidden;
  /* padding: ${props => (props.padding ? props.padding : '5%')}; */
  padding-top: 8px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 28px;
  margin-bottom: 0;
  ${props =>
    props.textAlign
      ? `text-align: ${props.textAlign};
       text-align-last: ${props.textAlign};`
      : null}
  text-overflow: ellipsis;
  ${props => (props.uppercase ? 'text-transform: uppercase;' : null)}
  white-space: nowrap;
  width: ${props => (props.width ? props.width : '100%')};
  ${props => (props.height ? `height: ${props.height};` : null)}
  ${props => (props.pulse ? `animation: ${pulse} 1s ease-out 3;` : null)}
  ${media['min-768']`
    height: 40px;
    /* padding: 17px; */
  `}
`;

const SelectorWrapper = styled.div`
  margin: ${props => (props.margin ? props.margin : '0 auto')};
  max-width: 500px;
  text-align: ${props => (props.align ? props.align : 'center')};
`;

export { Selector, SelectorWrapper };
